import React, { Component } from 'react';
import { Pagination, Progress, Form, Input, Button, Table } from 'antd';
import { DatePicker, Select, ConfigProvider, Icon, Breadcrumb } from 'antd';
import { Tag, Checkbox, message, Spin } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { apis } from '../api/index.js';
import moment from 'moment';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import TableEmpty from '../components/TableEmpty.js';
import { getSex, intelligentReviewStorage, formatDA, timeCalc } from '../utils';
import { changeListWidth, reviewStateOption } from '../utils';
import { getInstitutionOptions, ReviewIcon, formatFromTime } from '../utils';
import { formatToTime, getProvinceOption, timeFn, getDay } from '../utils';
import { institutionRecord, setScrollTop, getArea, breadItem } from '../utils';
import { calcTableHeight, showMoreSearch, fastDateOption } from '../utils';
import { breadBack, setSearchInfo, loadingOptionsHtml } from '../utils';

import throttle from 'lodash.throttle';
const { Option } = Select;
let autoRefreshReview = '';

const initState = {
  pageNum: 1,
  patName: '',
  timeTypeVal: false,
  defineTimeType: false,
  chestPa: undefined,
  areaProvince: undefined,
  status1: undefined,
  status2: undefined,
  status3: undefined,
  institutionId: undefined,
  recentDays: 2,
  dayRange: [getDay(-2) + ' 0:0:0', getDay(0) + ' 23:59:59'],
};

class IntelligentReview extends Component {
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    history: PropTypes.object,
    onUserInfoUpdated: PropTypes.func,
    setApplicationData: PropTypes.func,
    setCurrentSearchInfoData: PropTypes.func,
    userInfo: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = initState;

    this.throttledList = throttle(newState => this.getList(newState), 1000);

    this.formResize = throttle(newState => {
      //页面大小改变，更新table高度
      const newHeight = calcTableHeight(189) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  async componentDidMount() {
    const roleInfo = (this.props.userInfo.operationAuths || '').split(',');
    const isAnonymity = roleInfo.includes('S');

    //获取省份列表
    const data = await getArea(0);
    this.setState({
      isAnonymity,
      tableHeight: 0,
      loadingIconShow: false,
      searchLoading: false,
      list: [],
      total: 0,
      listWidth: 'calc(87% - 8px)',
      moreFilter: true,
      showMoreFilter: false,
      provinceList: data,
    });

    this.getInstitutionData();
    this.pageInit();
    intelligentReviewStorage(this.throttledList);
    this.reFreshList();
    window.addEventListener('resize', () => this.formResize());
    this.formResize();
  }

  pageInit = () => {
    const api = window.store.getState().api;
    const searchInfo = api.current.searchInfo;
    let state = searchInfo.reviewIntelligentscreening;
    state.defineTimeType = state.timeTypeVal;
    const newState = Object.assign({}, initState, state);
    this.throttledList(newState);
  };

  //自动刷新列表
  reFreshList = () => {
    autoRefreshReview = setInterval(() => {
      if (!document.getElementById('intelligentReview')) {
        clearInterval(autoRefreshReview);
      } else {
        const newState = { pageNum: this.state.pageNum };
        this.throttledList(newState);
      }
    }, 60000);
  };
  //获取列表
  getList = newState => {
    const rows = 20;
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      patName: updatedState.patName,
      chestPa: updatedState.chestPa,
      areaProvince: updatedState.areaProvince,
      state: updatedState.status1 ? [updatedState.status1] : [],
      state2: updatedState.status2 ? [updatedState.status2] : [],
      state3: updatedState.status3 ? [updatedState.status3] : [],
      pageNum: updatedState.pageNum,
      pageSize: rows,
      institutionId: updatedState.institutionId,
    };
    if (updatedState.defineTimeType) {
      if (updatedState.dayRange) {
        post.fromTime = formatFromTime(updatedState.dayRange);
        post.toTime = formatToTime(updatedState.dayRange);
      } else {
        post.fromTime = undefined;
        post.toTime = undefined;
      }
    } else {
      if (updatedState.recentDays !== undefined) {
        const dayRange = timeCalc(updatedState.recentDays);
        post.fromTime = dayRange.fromTime;
        post.toTime = dayRange.toTime;
      } else {
        post.fromTime = undefined;
        post.toTime = undefined;
      }
    }
    apis.tubeStudyReviewList(post).then(result => {
      this.setState({ loadingIconShow: false, searchLoading: false });
      if (result.code === '0') {
        result.data.list.forEach(item => {
          item.showChestPaValue = 'chestPa';
        });
        this.setState({ list: result.data.list, total: result.data.total });
      } else {
        if (result.code === '1009') this.props.history.push('/login');
        this.setState({ list: [], total: 0 });
      }
    });
  };

  doctorReview = (item, type) => {
    if (type === 1) {
      if (item.state === 10) {
        this.setState({ isLoading: true });
        //点击一审按钮开始审核
        apis.tubeStudyReview(item.id).then(res => {
          this.setState({ isLoading: false });
          if (res.code === '0') this.viewHeatmap(item, type);
          else {
            message.error(res.message);
            if (res.code === '1009') this.props.history.push('/login');
          }
        });
      } else this.viewHeatmap(item, type);
    } else {
      if (item.review2State === 10) this.tubeStudyPrivatReview(item, type);
      else if (item.review3State === 10) this.tubeStudyPrivatReview(item, type);
      else this.viewHeatmap(item, type);
    }
  };

  tubeStudyPrivatReview = (item, type) => {
    this.setState({ isLoading: true });
    apis.tubeStudyPrivatReview(item.id, type).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') this.viewHeatmap(item, type);
      else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //查看详情
  viewHeatmap = (item, type) => {
    item.subVos = item.dicomList;
    this.props.setApplicationData(item);

    const w = window.screen.width - 10;
    const h = window.screen.height - 105;

    const studyUid = item.studyUid;
    let url = `/viewer/study/${studyUid}?tubeId=${item.id}&from=screening&from1=review&type=${type}`;
    let str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${w},height=${h}`;

    window.open(url, 'viewer', str);
  };

  //点击搜索按钮
  handleSearch = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const newState = {
          patName: values.patName,
          chestPa: values.chestStatus,
          areaProvince: values.provice,
          status1: values.status1,
          status2: values.status2,
          status3: values.status3,
          institutionId: values.name ? values.name.join(',') : undefined,
          dayRange: values.dayRange,
          recentDays: values.recentDays,
          defineTimeType: this.state.timeTypeVal,
          timeTypeVal: this.state.timeTypeVal,

          pageNum: 1,
          loadingIconShow: true,
          searchLoading: true,
        };

        this.throttledList(newState);
        setSearchInfo(newState, 'reviewIntelligentscreening', this);
        setScrollTop();
      }
    });
  };

  //点击重置按钮
  handleReset = () => {
    const loadingState = { searchLoading: true };
    const newState = Object.assign({}, initState, loadingState);
    this.setState(newState);
    this.props.form.resetFields();
    this.getInstitutionData();
    this.throttledList(newState);
    setSearchInfo(initState, 'reviewIntelligentscreening', this);
    setScrollTop();
  };

  //获取部位列表
  getChestPa = record => {
    const dicomList = record.dicomList || [];
    let html = [],
      chestPa = false,
      otherPart = false;
    dicomList.forEach(item => {
      if (item.chestPa) chestPa = true;
      else otherPart = true;
    });
    if (chestPa)
      html.push(
        <Option key={0} value="chestPa">
          正位胸片
        </Option>
      );
    if (otherPart)
      html.push(
        <Option key={1} value="other">
          其他部位
        </Option>
      );

    if (html.length === 1 && chestPa)
      html = <span className="text-tag-chestpa">正位胸片</span>;
    else if (html.length === 1 && otherPart)
      html = <span className="text-tag-other">其他部位</span>;
    return { html, len: html.length };
  };

  //分页
  pageOnChange = (pageNum, pageSize) => {
    setScrollTop();
    const newState = { pageNum, searchLoading: true };
    this.throttledList(newState);
  };

  //获取机构列表
  getInstitutionData = async (name, area) => {
    const data = await institutionRecord(name, area);
    this.setState({ institutionData: data });
  };

  //机构下拉的查询功能
  handleInstitutionSearch = value => {
    const area = this.state.areaProvince;
    this.getInstitutionData(value, area);
  };

  //获取审核状态
  getReviewedStatusDetail = status => {
    let html;
    switch (status) {
      case 10:
        html = <Tag color="#F4A237">待审核</Tag>;
        break;
      case 20:
        html = <Tag color="#5EC8DD">审核中</Tag>;
        break;
      case 30:
        html = <Tag color="#78C493">已审核</Tag>;
        break;
      case 31:
        html = <Tag color="#5EC8DD">修改中</Tag>;
        break;
      default:
        html = <span>--</span>;
        break;
    }
    return html;
  };

  handleChangeSelect = (key, value) => {
    const newData = [...this.state.list];
    const index = newData.findIndex(item => key === item.id);
    if (index > -1) {
      const changedData = newData[index];
      changedData.showChestPaValue = value;
      changedData.part = value;
      newData[index] = changedData;
      this.setState({ list: newData });
    }
  };

  getColumns = () => {
    const { isAnonymity } = this.state;
    const columns = [];
    columns.push(
      {
        title: '姓名',
        dataIndex: 'patName',
        key: 'patName',
        width: 170,
        render: patName => (isAnonymity ? '***' : patName),
      },
      {
        title: '年龄',
        dataIndex: 'patAge',
        key: 'patAge',
        width: 80,
        render: patAge => (isAnonymity ? '***' : patAge),
      },
      {
        title: '性别',
        dataIndex: 'patSex',
        key: 'patSex',
        width: 80,
        render: patSex => (isAnonymity ? '***' : getSex(patSex)),
      },
      {
        title: '部位',
        dataIndex: '',
        key: 'dicomList',
        width: 120,
        render: (record, index) => {
          const dicomList = record.dicomList || [];
          const chestPaTrue = dicomList.find(item => item.chestPa === true);
          const defaultValue = chestPaTrue ? 'chestPa' : 'other';
          record.part = record.part || defaultValue;
          const result = this.getChestPa(record, index);
          return (
            <div>
              {dicomList.length > 0 ? (
                result.len === 2 ? (
                  <Select
                    size="small"
                    onChange={this.handleChangeSelect.bind(this, record.id)}
                    defaultValue={defaultValue}
                    value={record.part}
                    style={{ width: 90 }}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                  >
                    {result.html}
                  </Select>
                ) : (
                  result.html
                )
              ) : (
                '--'
              )}
            </div>
          );
        },
      },
      {
        title: 'AI肺结核筛查',
        dataIndex: '',
        key: 'abnormal',
        width: 180,
        render: record => {
          const dicomList = record.dicomList || [];
          const chestPaTrue = dicomList.find(item => item.chestPa === true);
          let value = 0;
          dicomList.forEach(item => {
            if (item.chestPa && value < item.confidence)
              value = item.confidence;
          });
          value = parseFloat((value * 100).toFixed(1));
          return (
            <div>
              {chestPaTrue && record.showChestPaValue === 'chestPa' ? (
                <Progress
                  strokeColor={value < 30 ? '#2F7BFF' : '#DC2F2F'}
                  percent={value}
                  status="active"
                  strokeWidth={5}
                  style={{ width: 50 }}
                />
              ) : (
                '--'
              )}
            </div>
          );
        },
      },
      {
        title: '一审状态',
        dataIndex: 'state',
        key: 'state',
        width: 120,
        render: value => <span>{this.getReviewedStatusDetail(value)}</span>,
      },
      {
        title: '审核时间倒计时',
        dataIndex: '',
        key: 'timeRemaining',
        width: 200,
        render: record => (
          <div>
            {record.state > 20 || !record.createTime ? (
              '--'
            ) : (
              <span className="text-red">
                <Icon type="clock-circle" />
                &nbsp; {timeFn(record.createTime)}
              </span>
            )}
          </div>
        ),
      },
      {
        title: '审核医生',
        dataIndex: 'reviewUserName',
        key: 'reviewUserName',
        width: 100,
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: '二审状态',
        dataIndex: 'review2State',
        key: 'review2State',
        width: 100,
        render: value => <span>{this.getReviewedStatusDetail(value)}</span>,
      },
      {
        title: '三审状态',
        dataIndex: 'review3State',
        key: 'review3State',
        width: 100,
        render: value => <span>{this.getReviewedStatusDetail(value)}</span>,
      },
      {
        title: '上传时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 200,
        render: createTime => <span>{formatDA(createTime)}</span>,
      },
      {
        title: '机构',
        dataIndex: 'institutionName',
        key: 'institutionName',
        render: value => <span>{isAnonymity ? '***' : value}</span>,
      },
      {
        title: '操作',
        dataIndex: '',
        key: 'id',
        align: 'center',
        // width: '10%',
        width: 130,
        fixed: 'right',
        render: record => <>{this.getButtons(record)}</>,
      }
    );

    return columns;
  };
  getButtons = record => {
    const { userInfo } = this.props;
    const uId = userInfo.id; //当前登录用户的id
    const roles = userInfo.operationAuths.split(','); //当前用户的操作权限

    const rUser = record.reviewUser; //一审用户
    const r2User = record.review2User; //二审用户
    const r3User = record.review3User; //三审用户

    const state1 = record.state; //一审状态
    const state2 = record.review2State; //二审状态
    const state3 = record.review3State; //三审状态
    const dicomList = record.dicomList;
    const canReview = dicomList.find(item => item.chestPa); //是否包含正位胸片

    const buttons = [];
    if (canReview) {
      if (
        state1 === 30 &&
        roles.includes('R') &&
        uId !== r2User &&
        uId !== r3User
      ) {
        buttons.push(
          <Button
            type="link"
            key={3}
            className="btn-viewdetail"
            onClick={this.doctorReview.bind(this, record, 1)}
          >
            <ReviewIcon />
            修改一审
          </Button>
        );
      }
      if ((state1 === 10 && roles.includes('V')) || uId === rUser) {
        buttons.push(
          <Button
            type="link"
            key={1}
            className="btn-viewdetail"
            onClick={this.doctorReview.bind(this, record, 1)}
          >
            <ReviewIcon />
            一审
          </Button>
        );
      } else if ((state2 === 10 && roles.includes('V2')) || uId === r2User) {
        buttons.push(
          <Button
            type="link"
            key={2}
            className="btn-viewdetail"
            onClick={this.doctorReview.bind(this, record, 2)}
          >
            <ReviewIcon />
            二审
          </Button>
        );
      } else if ((state3 === 10 && roles.includes('V3')) || uId === r3User) {
        buttons.push(
          <Button
            type="link"
            key={3}
            className="btn-viewdetail"
            onClick={this.doctorReview.bind(this, record, 3)}
          >
            <ReviewIcon />
            三审
          </Button>
        );
      }
    }
    buttons.push(
      <Button
        type="link"
        key={0}
        className="btn-viewdetail"
        onClick={this.viewHeatmap.bind(this, record, 'V')}
      >
        <Icon type="eye" theme="filled" />
        查看
      </Button>
    );
    return buttons;
  };

  handleChangeProvince = value => {
    this.setState({ areaProvince: value });
    this.getInstitutionData('', value);
  };

  setTimeType = e => {
    this.setState({ timeTypeVal: e.target.checked });
  };
  setBackEvent = () => {
    // this.setSearchEvent('ns-066');
  };
  render() {
    let { list, institutionData, timeTypeVal, isAnonymity } = this.state;
    let { tableHeight, chestPa, moreFilter, showMoreFilter } = this.state;
    let { areaProvince, status1, status2, status3, institutionId } = this.state;
    let { patName, dayRange, recentDays, isLoading } = this.state;

    institutionId = institutionId ? institutionId.split(',') : [];
    institutionId = institutionId.map(item => +item);
    const { RangePicker } = DatePicker;
    const dateFormat = 'YYYY-MM-DD';

    const columns = this.getColumns();

    const { getFieldDecorator } = this.props.form;
    const institutionOptions = getInstitutionOptions(institutionData, 'id');

    let tableWidth = 1780;
    const screenWidth = document.body.clientWidth * 0.87 - 55;
    if (screenWidth > tableWidth) tableWidth = screenWidth;

    const loadingOptions = loadingOptionsHtml(this.state.searchLoading);

    const from = formatFromTime(dayRange);
    const to = formatToTime(dayRange);

    return (
      <div className="form-bg" id="intelligentReview">
        {isLoading && (
          <div className="spin-box-bg">
            <Spin indicator={<Icon type="loading" spin />} />
          </div>
        )}
        <ConnectedMenu toggleCollapsed={changeListWidth.bind(this, this)} />

        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={changeListWidth.bind(this, this)}
            login={false}
            home={true}
          />
          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>
                {breadItem(['应用审核', '智能筛查审核列表'])}
              </Breadcrumb>
              {breadBack(this)}
            </div>
            <div className="box" style={{ width: this.state.listWidth }}>
              <div className="left">
                <Form
                  className={`ant-advanced-search-form${
                    !moreFilter && showMoreFilter ? ' notOverflow' : ''
                  }`}
                  onSubmit={this.handleSearch}
                  layout="inline"
                >
                  <div className="searchBox">
                    <div className="searchBoxContent">
                      <div className="search-unit">
                        <Form.Item
                          style={{
                            display: timeTypeVal === true ? '' : 'none',
                          }}
                          label="上传时间"
                          colon={false}
                        >
                          <ConfigProvider locale={zh_CN}>
                            {getFieldDecorator('dayRange', {
                              initialValue:
                                from && to
                                  ? [
                                      moment(from, dateFormat),
                                      moment(to, dateFormat),
                                    ]
                                  : null,
                            })(
                              <RangePicker
                                format={dateFormat}
                                allowClear={true}
                                placeholder={['上传时间', '结束时间']}
                                style={{ width: 240 }}
                              />
                            )}
                          </ConfigProvider>
                        </Form.Item>
                        <Form.Item
                          style={{
                            display: timeTypeVal === true ? 'none' : '',
                          }}
                          label="上传时间"
                          colon={false}
                        >
                          {getFieldDecorator('recentDays', {
                            initialValue: recentDays,
                          })(
                            <Select
                              defaultActiveFirstOption={true}
                              showArrow={false}
                              filterOption={false}
                              allowClear={true}
                              style={{ width: 240 }}
                            >
                              {fastDateOption()}
                            </Select>
                          )}
                        </Form.Item>
                        <Form.Item label="" colon={false}>
                          {getFieldDecorator('defineTimeType', {})(
                            <Checkbox
                              checked={timeTypeVal}
                              onChange={this.setTimeType}
                            >
                              自定义
                            </Checkbox>
                          )}
                        </Form.Item>
                      </div>
                      <div className="search-unit">
                        <Form.Item
                          label="机构"
                          colon={false}
                          className="form-provice"
                        >
                          {getFieldDecorator('provice', {
                            initialValue: areaProvince,
                          })(
                            <Select
                              showSearch
                              placeholder="选择省份"
                              defaultActiveFirstOption={false}
                              filterOption={false}
                              showArrow={false}
                              onChange={this.handleChangeProvince}
                              notFoundContent={null}
                              allowClear={true}
                              style={{ width: 150 }}
                              disabled={isAnonymity}
                            >
                              {getProvinceOption(this.state.provinceList)}
                            </Select>
                          )}
                        </Form.Item>

                        <Form.Item
                          label=""
                          colon={false}
                          className="form-institute"
                        >
                          {getFieldDecorator('name', {
                            initialValue: institutionId,
                          })(
                            <Select
                              className="institution-selection"
                              showSearch
                              mode="multiple"
                              placeholder="请输入机构名称"
                              defaultActiveFirstOption={false}
                              showArrow={false}
                              filterOption={false}
                              onSearch={this.handleInstitutionSearch}
                              onChange={this.handleChange}
                              allowClear={true}
                              style={{ width: 220 }}
                              disabled={isAnonymity}
                            >
                              {institutionOptions}
                            </Select>
                          )}
                        </Form.Item>
                      </div>
                      <Form.Item label="部位" colon={false}>
                        {getFieldDecorator('chestStatus', {
                          initialValue: chestPa,
                        })(
                          <Select
                            allowClear={true}
                            placeholder="选择部位"
                            style={{ width: 160 }}
                          >
                            <Option value="true">正位胸片</Option>
                            <Option value="false">其他部位</Option>
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="姓名" colon={false}>
                        {getFieldDecorator('patName', {
                          initialValue: patName,
                        })(
                          <Input
                            allowClear={true}
                            style={{ width: 160 }}
                            placeholder="请输入患者姓名"
                            disabled={isAnonymity}
                          />
                        )}
                      </Form.Item>
                      <Form.Item label="一审状态" colon={false}>
                        {getFieldDecorator('status1', {
                          initialValue: status1,
                        })(
                          <Select
                            placeholder="请选择状态"
                            allowClear={true}
                            style={{ width: 160 }}
                          >
                            {reviewStateOption()}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="二审状态" colon={false}>
                        {getFieldDecorator('status2', {
                          initialValue: status2,
                        })(
                          <Select
                            placeholder="请选择状态"
                            allowClear={true}
                            style={{ width: 160 }}
                          >
                            {reviewStateOption()}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="三审状态" colon={false}>
                        {getFieldDecorator('status3', {
                          initialValue: status3,
                        })(
                          <Select
                            placeholder="请选择状态"
                            allowClear={true}
                            style={{ width: 160 }}
                          >
                            {reviewStateOption()}
                          </Select>
                        )}
                      </Form.Item>
                    </div>
                  </div>
                  <div className="searchOptBox">
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn-search"
                        disabled={this.state.searchLoading}
                      >
                        {this.state.loadingIconShow ? (
                          <Icon type="sync" spin />
                        ) : (
                          <Icon type="search" />
                        )}
                        搜索
                      </Button>
                      <Button
                        style={{ marginLeft: 8 }}
                        icon="redo"
                        className="btn-reset"
                        disabled={this.state.searchLoading}
                        onClick={this.handleReset}
                      >
                        重置
                      </Button>
                    </Form.Item>
                    {showMoreFilter && (
                      <Button
                        type="link"
                        className="moreFilter"
                        onClick={() => {
                          this.setState({ moreFilter: !moreFilter });
                        }}
                        icon={moreFilter ? 'down' : 'up'}
                      >
                        {moreFilter ? '展开' : '收起'}
                      </Button>
                    )}
                  </div>
                </Form>
                <div className="history-list">
                  <Table
                    loading={loadingOptions}
                    columns={columns}
                    dataSource={list}
                    rowKey={record => record.id}
                    key={record => record.id}
                    pagination={false}
                    className="list-item"
                    scroll={{ x: tableWidth, y: tableHeight }}
                    locale={{ emptyText: <TableEmpty /> }}
                  />
                  <ConfigProvider locale={zh_CN}>
                    <Pagination
                      onChange={this.pageOnChange}
                      total={this.state.total}
                      pageSize={20}
                      className="list-page"
                      current={this.state.pageNum}
                      showQuickJumper
                      size="small"
                      showTotal={() => `共${this.state.total}条`}
                    ></Pagination>
                  </ConfigProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(IntelligentReview));
